import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { LandingPageContainer } from '@ori/editorial-category';
import { Layout } from '~/containers/Layout';
const EditorialsLandingPage = (param)=>{
    let { breadcrumbs, data, layoutPage } = param;
    return /*#__PURE__*/ _jsx(Layout, {
        layoutPage: layoutPage,
        children: /*#__PURE__*/ _jsx(LandingPageContainer, {
            breadcrumbs: breadcrumbs,
            data: data
        })
    });
};
export var __N_SSG = true;
export default EditorialsLandingPage;
